import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../data';

const Footer = () => {
  return (
    <footer className="bg-slate-50 text-slate-900 py-16 border-t border-slate-200">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-16">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6 mb-8">
              <img src="/Screenshot_2026-04-29_at_15.35.22-removebg-preview.png" alt="GMA Logo" className="h-14 lg:h-12 object-contain" />
              <div className="w-px h-10 lg:h-8 bg-slate-200 hidden md:block"></div>
              <img src="https://assets.auxodev.dk/assets/f4225015-9d61-46d9-9e4c-356d5fd3c807/2e4fbde1-e418-4ccb-b10f-30b3d1b42720.png" alt="Partner Logo" className="h-12 lg:h-10 object-contain" />
            </Link>
            <p className="text-slate-600 max-w-sm leading-relaxed mb-10 font-medium">
              GMA er din partner i den grønne omstilling. Vi leverer fremtidens energilagringsløsninger.
            </p>
          </div>
          
          <div>
            <h4 className="font-black mb-8 text-slate-900 uppercase tracking-widest text-xs opacity-40">Navigation</h4>
            <ul className="space-y-4 text-slate-600 text-sm font-bold">
              <li><Link to="/" className="hover:text-black transition-colors uppercase tracking-tight">Forside</Link></li>
              <li><Link to="/produkter" className="hover:text-black transition-colors uppercase tracking-tight">Produkter</Link></li>
              <li><Link to="/projekter" className="hover:text-black transition-colors uppercase tracking-tight">Projekter</Link></li>
              <li><Link to="/om-os" className="hover:text-black transition-colors uppercase tracking-tight">Om os</Link></li>
              <li><Link to="/kontakt" className="hover:text-black transition-colors uppercase tracking-tight">Kontakt</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-black mb-8 text-slate-900 uppercase tracking-widest text-xs opacity-40">Kontakt</h4>
            <ul className="space-y-4 text-slate-600 text-sm font-bold uppercase tracking-tight">
              <li>E: {siteConfig.contact.email}</li>
              <li>T: {siteConfig.contact.phone}</li>
              <li>A: {siteConfig.contact.address}, {siteConfig.contact.zipCity}</li>
              <li>CVR: {siteConfig.contact.cvr}</li>
            </ul>
          </div>
        </div>
        
        <div className="pt-12 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between gap-8">
          <p className="text-slate-400 text-[10px] font-black uppercase tracking-[0.2em] text-center md:text-left">
            © {new Date().getFullYear()} GMA (Global Mobile Access) ApS. Alle rettigheder forbeholdes.
          </p>
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10 text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
            <a href="#" className="hover:text-black transition-colors">Privatlivspolitik</a>
            <a href="#" className="hover:text-black transition-colors">Handelsbetingelser</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
